import React, { useState, useContext } from 'react';
import AppContext from '../../contexts/AppContext';
import { X } from 'lucide-react';
import * as firestoreService from '../../services/firestoreService';
import SecurityUtils from '../../utils/security';

const ReportModal = ({ onClose, reportType, targetId, targetUserId }) => {
  const { currentUser, reports, setReports, showAlert } = useContext(AppContext);
  const [selectedReason, setSelectedReason] = useState('');
  const [description, setDescription] = useState('');

  const reportReasons = {
    post: [
      'Spam',
      'Harassment or bullying',
      'Hate speech or symbols',
      'Violence or dangerous content',
      'Inappropriate content',
      'False information',
      'Scam or fraud',
      'Intellectual property violation',
      'Other'
    ],
    user: [
      'Spam',
      'Harassment or bullying',
      'Hate speech',
      'Fake account',
      'Scam or fraud',
      'Inappropriate behavior',
      'Impersonation',
      'Other'
    ]
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedReason) {
      showAlert('Please select a reason', 'Error');
      return;
    }

    const newReport = {
      id: 'r' + Date.now(),
      reporterId: currentUser.id,
      reportedUserId: targetUserId,
      reportedContentId: reportType === 'post' ? targetId : null,
      reportedContentType: reportType,
      reason: selectedReason,
      description: SecurityUtils.sanitizeText(description.trim()),
      status: 'pending',
      severity: 'medium',
      timestamp: new Date().toISOString()
    };

    setReports([...reports, newReport]);
    firestoreService.createReport(newReport).catch(err => console.error('Error creating report:', err));
    showAlert('Report submitted. Our team will review it shortly.', 'Success');
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-black border border-gray-800 rounded-lg p-6 max-w-md w-full">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-xl font-bold text-white">Report {reportType === 'post' ? 'Post' : 'User'}</h3>
          <button onClick={onClose} className="text-white hover:text-gray-300">
            <X className="w-6 h-6" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-white mb-2">Reason for report *</label>
            <select
              value={selectedReason}
              onChange={(e) => setSelectedReason(e.target.value)}
              className="w-full px-3 py-2 bg-gray-900 text-white border border-gray-700 rounded-lg focus:outline-none focus:border-[#16a34a]"
              required
            >
              <option value="">Select a reason...</option>
              {reportReasons[reportType].map((reason) => (
                <option key={reason} value={reason}>{reason}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-white mb-2">Additional details (optional)</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Provide any additional context..."
              rows={4}
              className="w-full px-3 py-2 bg-gray-900 text-white border border-gray-700 rounded-lg focus:outline-none focus:border-[#16a34a] resize-none"
            />
          </div>

          <div className="flex space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-2 py-1 bg-gray-700 text-white rounded-lg hover:bg-gray-600 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 px-2 py-1 bg-red-600 text-pure-white rounded-lg hover:bg-red-700 transition-colors"
            >
              Submit Report
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReportModal;
